import styled from 'styled-components';
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

import { MirandaButton } from '@/components/Button/BaseButton';

export const SectionWrapper = styled.section`
  padding: 40px 0;
  background-color: rgba(${getToken('color-background-tertiary')});
  text-align: center;

  ${screen.md} {
    padding: 50px 0;
  }

  ${screen.lg} {
    padding: 80px 0;
  }

  ${screen.xxlg} {
    padding: 100px 0;
  }
`;

export const TitleWrapper = styled.div`
  margin: 0 0 24px;

  ${screen.lg} {
    margin: 0 0 36px;
  }
`;

export const AwardsBadges = styled.aside`
  margin: 20px auto;

  svg {
    width: 46px;
    height: auto;
    margin: 0 10px;
  }

  ${screen.lg} {
    margin: 36px auto;

    svg {
      width: 94px;
      height: auto;
      margin: 0 18px;
    }
  }
`;

export const BadgeContainer = styled.div`
  display: inline-flex;
  margin: 6.5px;

  ${screen.lg} {
    margin: 18px;
  }
`;

export const Badge = styled.img`
  height: auto;
  width: 55px;

  ${screen.md} {
    width: 75px;
  }
  ${screen.lg} {
    width: 92px;
  }
`;

export const StyledButton = styled(MirandaButton)`
  padding: 16px;
  font-family: ${getToken('font-family-default')};
  color: rgb(${getToken('color-text-inverted')});
  background-color: rgb(${getToken('color-primary-60')});
  font-weight: ${getToken('font-weight-bold')};
  margin-bottom: 50px;

  ${screen.md} {
    padding: 16px 52px;
  }

  ${screen.xxlg} {
    margin-bottom: 48px;
  }
`;

export const Title = styled.h2`
  font-family: ${getToken('platform-font-title')};
  font-weight: ${getToken('font-weight-bold')};
  color: rgb(${getToken('color-text-primary')});
  text-align: center;

  font-size: 26px;
  line-height: 39px;
  margin: 0px auto 28px;

  ${screen.lg} {
    margin: 0px auto 36px;
    font-size: 38px;
    line-height: 47.5px;
  }

  ${screen.xxlg} {
    font-size: 48px;
    line-height: 60px;

    br {
      display: none;
    }
  }
`;

export const IntroText = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: ${getToken('font-weight-regular')};
  color: rgb(${getToken('color-text-primary')});
  font-size: 14px;
  line-height: 21px;
  margin: 0px auto;
  text-wrap: balance;

  ${screen.lg} {
    font-size: 20px;
    line-height: 36px;
  }
`;

export const CTAWrapper = styled.div`
  display: flex;
  padding: 24px 0 0;
  gap: 16px;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  ${screen.md} {
    gap: 32px;
    flex-direction: row;

    a:nth-child(1) {
      width: auto;
    }
  }

  ${screen.lg} {
    padding: 36px 0 0;
  }
`;

export const LogoWrapper = styled.div`
  margin: auto auto 24px;
  width: 242px;

  ${screen.md} {
    width: 254px;
  }

  ${screen.lg} {
    width: 441px;
    margin: auto auto 36px;
  }

  svg,
  path {
    width: 100%;
    height: auto;
    color: rgb(${getToken('color-primary-100')});
    fill: rgb(${getToken('color-primary-100')});
  }
`;

// ---- //

export const MediaWrapper = styled.div`
  position: relative;
  margin: auto;
  max-width: 315px;
  height: 177px;

  ${screen.md} {
    max-width: 690px;
    height: 387px;
  }

  ${screen.lg} {
    max-width: 826px;
    height: 464px;
  }

  ${screen.xxlg} {
    max-width: 1086px;
    height: 610px;
  }
`;
